import { asksDemand, asksEncryption, demandMade, type Intake } from "./intake"

/**
 * One question per page, and only what the first minutes of the plan need. Everything else (states,
 * systems, backups, headcount, the "confirmed" time) is asked after the plan appears, as open questions
 * and on the My answers page. The id is what appears in the URL (?q=).
 */
export const WIZARD_SCREENS = [
  "type", "active", "access", "taken", "noticed", "org", "where", "data", "encrypted", "demand", "paid", "help",
] as const
export type ScreenId = (typeof WIZARD_SCREENS)[number]

/** Which screens apply, given what has been answered so far. */
export function screensFor(i: Intake): ScreenId[] {
  return WIZARD_SCREENS.filter((s) => {
    if (s === "encrypted") return asksEncryption(i.incidentType) && i.dataTypes.some((d) => d !== "none-known")
    if (s === "demand") return asksDemand(i.incidentType)
    if (s === "paid") return asksDemand(i.incidentType) && demandMade(i)
    return true
  })
}
